/* eslint-disable class-methods-use-this */
import PCLNAnalytics from '@pcln/analytics'
import { ANALYTICS_CATEGORY_PACKAGES } from '../constants/analytics'

class Analytics {
  fireEvent({
    category = ANALYTICS_CATEGORY_PACKAGES,
    action = '',
    data = '',
    event = '',
    label = ''
  }) {
    PCLNAnalytics.logEvent({
      action,
      category,
      data,
      event,
      label
    })
  }
}

export default new Analytics()
